<custom-modal-card *ngIf="{} as STATE" class="mat-dialog-transparent">
  <ng-container header>
    <default-modal-header
      [title]="modalTitle"
      [description]="modalDescription"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form [formGroup]="form" class="resource-form">
      <article>
        <file-upload
          (fileChange)="setFile('teaser', $event)"
          [preloadedFiles]="
            program?.teaser ? [program!.teaser!.attachment!] : []
          "
          [label]="'Faites glisser le teaser ici.'"
          [accept]="supportedVideoExtensions"
          [maxSize]="8_388_608"
        ></file-upload>
        <mat-error *ngIf="teaserControl?.getError('httpError') as httpError">
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Titre du teaser *</mat-label>
        <mat-form-field>
          <input
            formControlName="teaserTitle"
            matInput
            placeholder="Entrez un titre (100 charactères max)."
          />
        </mat-form-field>
        <mat-error
          *ngIf="form.get('teaserTitle')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Couleur du titre</mat-label>
        <color-picker-bar
          (colorChange)="setColor($event)"
          [colors]="colors"
          [defaultColor]="form.get('teaserTitleColor')?.value || defaultColor"
        ></color-picker-bar>
        <mat-error
          *ngIf="
            form.get('teaserTitleColor')?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Description du teaser *</mat-label>
        <mat-form-field>
          <textarea
            formControlName="teaserDescription"
            matInput
            rows="3"
            placeholder="Entrez le texte à afficher (200 charactères max)."
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="
            form.get('teaserDescription')?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Couleur de la description</mat-label>
        <color-picker-bar
          (colorChange)="setColor($event, 'teaserDescriptionColor')"
          [colors]="colors"
          [defaultColor]="
            form.get('teaserDescriptionColor')?.value || defaultColor
          "
        ></color-picker-bar>
        <mat-error
          *ngIf="
            form
              .get('teaserDescriptionColor')
              ?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
    </form>
  </ng-container>
  <footer footer class="resource-form">
    <button
      (click)="update()"
      [attr.loading]="isLoading"
      [disabled]="!isFormValid || isLoading"
      class="btn btn--primary-light btn--full"
    >
      Sauvegarder le teaser
    </button>
  </footer>
</custom-modal-card>
